(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  if (!window.sbxHorizontalFacetsInstalled) {
    window.sbxHorizontalFacetsInstalled = true;
    const dropdownSelector = '.sbx-horizontal-facets .sbx-filter-dropdown';
    const positionDropdown = (dropdown) => {
      dropdown.removeAttribute('data-align-end');
      const panel = dropdown.querySelector('.sbx-filter-dropdown__panel');
      if (panel && panel.getBoundingClientRect().right > document.documentElement.clientWidth - 16) dropdown.setAttribute('data-align-end', '');
    };
    document.addEventListener('toggle', (event) => {
      const dropdown = event.target;
      if (!(dropdown instanceof Element) || !dropdown.matches(dropdownSelector) || !dropdown.open) return;
      document.querySelectorAll(dropdownSelector + '[open]').forEach((other) => { if (other !== dropdown) other.open = false; });
      positionDropdown(dropdown);
    }, true);
    document.addEventListener('click', (event) => {
      document.querySelectorAll(dropdownSelector + '[open]').forEach((dropdown) => { if (!dropdown.contains(event.target)) dropdown.open = false; });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const dropdown = event.target.closest?.(dropdownSelector + '[open]');
      if (dropdown) { dropdown.open = false; dropdown.querySelector('summary').focus(); event.preventDefault(); }
    });
    document.addEventListener('focusin', (event) => {
      document.querySelectorAll(dropdownSelector + '[open]').forEach((dropdown) => { if (!dropdown.contains(event.target)) dropdown.open = false; });
    });
    window.addEventListener('resize', () => {
      document.querySelectorAll(dropdownSelector + '[open]').forEach((dropdown) => {
        if (window.innerWidth < 1000) dropdown.open = false;
        else positionDropdown(dropdown);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbx-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sbx-product-tabs')) {
    customElements.define('sbx-product-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.panels = Array.from(this.querySelectorAll('.sbx-tabs__panel'));
        this.nav = this.querySelector('.sbx-tabs__nav');
        this.selected = 0;
        this.nav.setAttribute('role', 'tablist');
        this.nav.setAttribute('aria-label', this.getAttribute('aria-label'));
        this.buttons = this.panels.map((panel, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'sbx-tabs__tab';
          button.id = panel.id + '-tab';
          button.textContent = panel.querySelector('summary').childNodes[0].textContent.trim();
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-controls', panel.id);
          button.addEventListener('click', () => this.select(index));
          button.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.panels.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.panels.length) % this.panels.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.panels.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.buttons[next].focus();
          });
          this.nav.append(button);
          return button;
        });
        this.media = matchMedia('(min-width: 1000px)');
        this.onModeChange = () => this.updateMode();
        this.media.addEventListener('change', this.onModeChange);
        this.updateMode();
      }
      disconnectedCallback() {
        this.media?.removeEventListener('change', this.onModeChange);
        this.nav?.replaceChildren();
        this.initialized = false;
      }
      select(index) {
        this.selected = index;
        this.buttons.forEach((button, i) => {
          button.setAttribute('aria-selected', String(i === index));
          button.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
          this.panels[i].open = i === index;
        });
      }
      updateMode() {
        const desktop = this.media.matches;
        const focusIndex = this.buttons.indexOf(document.activeElement);
        this.toggleAttribute('data-desktop', desktop);
        this.nav.hidden = !desktop;
        this.panels.forEach((panel, i) => {
          if (desktop) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', this.buttons[i].id);
            panel.tabIndex = 0;
          } else {
            panel.hidden = false;
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('tabindex');
            panel.open = i === this.selected;
          }
        });
        if (desktop) this.select(this.selected);
        else if (focusIndex >= 0) this.panels[focusIndex].querySelector('summary').focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
